if (!customElements.get('quick-add-size-form')) {
  class QuickAddSizeForm extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('.quick-add-sizes__trigger');
      this.form    = this.querySelector('form');
      this.idInput = this.form.querySelector('input[name="id"]');
      this.panel   = document.getElementById(this.dataset.panelId);

      this.trigger.addEventListener('click', this.togglePanel.bind(this));

      if (this.panel) {
        this.panel.addEventListener('change', this.onSizeChange.bind(this));
      }
    }

    togglePanel(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!this.panel) return;
      this.panel.classList.contains('is-open') ? this.closePanel() : this.openPanel();
    }

    openPanel() {
      // cerrar otros paneles abiertos en la página
      document.querySelectorAll('.quick-add-sizes__panel.is-open').forEach((p) => {
        if (p !== this.panel) p.classList.remove('is-open');
      });
      this.panel.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', 'true');

      this._outsideClick = (ev) => {
        if (!this.contains(ev.target) && !this.panel.contains(ev.target)) this.closePanel();
      };
      setTimeout(() => document.addEventListener('click', this._outsideClick), 0);
    }

    closePanel() {
      this.panel.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');
      if (this._outsideClick) {
        document.removeEventListener('click', this._outsideClick);
        this._outsideClick = null;
      }
    }

    onSizeChange(event) {
      if (event.target.type !== 'radio') return;
      const variantId = event.target.dataset.variantId;
      const available = event.target.dataset.available === 'true';
      if (!variantId || !available) return;
      this.idInput.value = variantId;
      this.addToCart();
    }

    async addToCart() {
      this.classList.add('is-loading');
      this.panel?.classList.add('is-loading');
      this.trigger.setAttribute('disabled', 'disabled');

      const formData = new FormData(this.form);
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        formData.append('sections', ['cart-drawer', 'cart-icon-bubble'].join(','));
        formData.append('sections_url', window.location.pathname);
      }

      try {
        const res = await fetch(`${window.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || res.statusText);
        }
        const result = await res.json();

        if (cartDrawer && result.sections) {
          cartDrawer.renderContents(result);
          if (typeof cartDrawer.open === 'function') cartDrawer.open();
        } else {
          window.location.href = window.routes.cart_url;
        }
        this.closePanel();
      } catch (e) {
        console.error('[quick-add-sizes] error:', e);
        this.trigger.textContent = 'Error';
      } finally {
        this.classList.remove('is-loading');
        this.panel?.classList.remove('is-loading');
        this.trigger.removeAttribute('disabled');
      }
    }
  }

  customElements.define('quick-add-size-form', QuickAddSizeForm);
}